import { appActions, appSelectors } from '@appStore/reducers/app'
import store from '@appStore/store'
import { connectorAPI } from 'actions/connector'
import { httpRequest } from 'api/httpRequest'
import { CONSTS } from 'config/objectConst'
import { initImportRunnerBroker } from '../../import-runner/initBrokerDeps'

import { createAppExportConnector } from './appExportConnector'
import { appConnector } from './singleton'

async function onSnailyProfileChange() {
	const state = store.getState()

	const hours = appSelectors.appProfile(state)?.workingHoursSet

	/*if profile is completely filled*/
	if (hours) {
		await connectorAPI.getSnailyProfile()
	}

	await connectorAPI.setUpInit()
}

function onSnailySignIn() {
	const state = store.getState()

	const token = appSelectors.token(state)

	if (!token) {
		connectorAPI.setUpInit()
	}
}

function saveToRedux() {
	const saveAction = appActions.createConnector(appConnector)
	store.dispatch(saveAction)

	const appExportConnector = createAppExportConnector()
	store.dispatch(appActions.setAppExportConnector(appExportConnector))

	const appDeps = {
		connectorAPI,
		connector: appConnector,
		appExportConnector,
		CONSTS,
		httpRequest
	}
	initImportRunnerBroker(appDeps)
}

function setUpEvents() {
	appConnector.eventHandlers.addSnailySignedInEventHandler(onSnailySignIn)
	appConnector.eventHandlers.addSnailyProfileChangedEventHandler(
		onSnailyProfileChange
	)
}

export { saveToRedux, setUpEvents }
